<div class="home">
    
    <h1>Lemon Group - Appointment</h1>
    <img src="assets/images/logoLG.png" alt="logo">
    
</div>